/* import __COLOCATED_TEMPLATE__ from './trigger-btn.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { TDate } from 'volta/models/types/calendar';
import type { TSize } from 'volta/utils/style-utils';

export interface TasksTriggerBtnSignature {
  Args: {
    criticality?: string;
    disabled?: boolean;
    minDueDate?: TDate;
    minimized?: boolean;
    onClick?: () => void;
    showDueDate?: boolean;
    size?: TSize;
    tasksCount?: number;
  };
  Element: HTMLElement;
}

const TasksTriggerBtnComponent = templateOnlyComponent<TasksTriggerBtnSignature>();

export default TasksTriggerBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Tasks::TriggerBtn': typeof TasksTriggerBtnComponent;
    'tasks/trigger-btn': typeof TasksTriggerBtnComponent;
  }
}
